import { FC, useContext } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../../app/modules/auth";
import { Languages } from "./Languages";
import { useIntl } from "react-intl";
import { ProfileImageContext } from "../../../helpers/ProfileImageContext";

const HeaderUserMenu: FC = () => {
  const intl = useIntl();
  const { currentUser, logout } = useAuth();
  const { profileImageState } = useContext(ProfileImageContext);

  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
      data-kt-menu="true"
    >
      <div className="menu-item px-3">
        <div className="menu-content d-flex align-items-center px-3">
          <div className="symbol symbol-50px me-5">
            <img src={profileImageState.profile_image} alt="profile_image" />
          </div>

          <div className="d-flex flex-column">
            <div className="fw-bolder d-flex align-items-center fs-5">
              {currentUser?.first_name}
              <span className="badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2">
                {intl.formatMessage({
                  id: "MENU.HEADER.USERMENU.STATUS",
                })}
              </span>
            </div>
            <p className="fw-bold text-muted text-hover-primary fs-7">
              {currentUser?.email}
            </p>
          </div>
        </div>
      </div>

      <div className="separator my-2"></div>

      <div className="menu-item px-5">
        <Link to="/profile" className="menu-link px-5">
          {intl.formatMessage({
            id: "MENU.HEADER.USERMENU.MYPROFILE",
          })}
        </Link>
      </div>

      <div className="separator my-2"></div>

      <Languages />

      <div className="menu-item px-5 my-1">
        <Link to="/profile" className="menu-link px-5">
          {intl.formatMessage({
            id: "MENU.HEADER.USERMENU.ACCOUNTMANAGEMENT",
          })}
        </Link>
      </div>

      <div className="menu-item px-5">
        <p onClick={logout} className="menu-link px-5">
          {intl.formatMessage({
            id: "MENU.HEADER.USERMENU.EXIT",
          })}
        </p>
      </div>
    </div>
  );
};

export { HeaderUserMenu };
